import React from 'react';
import './Loading.css';

const Loading = ({ text = null }) => {
    return (
        <div
            className="loading-container"
            role="status"
            aria-live="polite"
            aria-label={text || 'در حال بررسی'}
        >
            <div className="loading-spinner-premium" aria-hidden="true"></div>
            <div className="loading-text-slot" aria-hidden={!text}>
                {text && (
                    <div className="loading-text">
                        {text}
                        <div className="loading-dots" aria-hidden="true">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Loading;
